var PURCHASE_CLUSTER_PADDING, StickyHandler, StickyPurchaseCluster;

StickyHandler = require('./sticky_handler');

PURCHASE_CLUSTER_PADDING = 12;

StickyPurchaseCluster = window.StickyPurchaseCluster != null ? window.StickyPurchaseCluster : window.StickyPurchaseCluster = {};

StickyPurchaseCluster.init = function(payload, done) {
  return $(function() {
    var container, element;
    element = $("#purchase-cluster > div");
    container = $('.deal-container');
    new StickyHandler(element, container, PURCHASE_CLUSTER_PADDING);
    return done();
  });
};

module.exports = StickyPurchaseCluster;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9kZWFsL2Rlc2t0b3BfMjAxNi9mcm9udGVuZC9zdGlja3lfcHVyY2hhc2VfY2x1c3Rlci5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ha2VzaGFyaS9uYXBpc3RyYW5vL2J1aWxkLzE0OTU2NjA4OTgyNDktNDM5Ni9wcm9kdWN0aW9uLTIwMTcuMDUuMjRfMjEuMTkvZGVhbC9tb2R1bGVzL2RlYWwvZGVza3RvcF8yMDE2L2Zyb250ZW5kL3N0aWNreV9wdXJjaGFzZV9jbHVzdGVyLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLGFBQUEsR0FBZ0IsT0FBQSxDQUFRLGtCQUFSOztBQUVoQix3QkFBQSxHQUEyQjs7QUFFM0IscUJBQUEsMENBQXdCLE1BQU0sQ0FBQyx3QkFBUCxNQUFNLENBQUMsd0JBQXlCOztBQUV4RCxxQkFBcUIsQ0FBQyxJQUF0QixHQUE2QixTQUFDLE9BQUQsRUFBVSxJQUFWO1NBQzNCLENBQUEsQ0FBRSxTQUFBO0FBQ0EsUUFBQTtJQUFBLE9BQUEsR0FBVSxDQUFBLENBQUUseUJBQUY7SUFDVixTQUFBLEdBQVksQ0FBQSxDQUFFLGlCQUFGO0lBQ1osSUFBSSxhQUFKLENBQWtCLE9BQWxCLEVBQTJCLFNBQTNCLEVBQXNDLHdCQUF0QztXQUVBLElBQUEsQ0FBQTtFQUxBLENBQUY7QUFEMkI7O0FBUzdCLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
